import { EventEmitter } from "events";
import { StandaloneModalProps } from "../../components/layout/StandaloneModal";

export type PanelStandaloneMessage = StandaloneModalProps & {
  priority?: number;
  key: string;
};

const eventEmitterKey = "panelChange";
type CallbackType = (details: PanelStandaloneMessage[]) => void;

class PanelStandaloneManager extends EventEmitter {
  constructor() {
    super();
    this.panelDetails = [];
  }

  panelDetails: PanelStandaloneMessage[];

  addPanelStandalone(detail: PanelStandaloneMessage) {
    const filteredDetails = this.panelDetails.filter((p) => p.key === detail.key);
    this.panelDetails = [...filteredDetails, detail];
    this.panelDetails.sort((a, b) => (a.priority ?? -1) - (b.priority ?? -1));
    this.emitChange();
  }

  remove(key: string) {
    this.panelDetails = this.panelDetails.filter((p) => p.key !== key);
    this.emitChange();
  }

  emitChange() {
    this.emit(eventEmitterKey, this.panelDetails);
  }

  addChangeListener(callback: CallbackType) {
    this.addListener(eventEmitterKey, callback);
  }

  removeChangeListener(callback: CallbackType) {
    this.removeListener(eventEmitterKey, callback);
  }
}

export default new PanelStandaloneManager();
